export default __webpack_public_path__ + "static/media/m6.a47990a0.svg";